import React from 'react'

import Modal from '../../../../UI/Modal/Modal'
import Footer from './Footer/Footer'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import { withTranslate } from 'react-redux-multilingual'

const copyModal = ({ open, cancelled, copySaved, copyForm, copyInputChanged, translate }) => {
  let formValid = true
  const copyInputs = Object.entries(copyForm).map(form => {
    const [formKey, formAttrs] = form
    formValid = formValid && formAttrs.valid
    return (
      <InputGroup
        key={formKey}
        label={formAttrs.label}
        inputType={formAttrs.elementType}
        configs={formAttrs.elementConfig}
        invalid={!formAttrs.valid}
        validations={formAttrs.validation}
        touched={formAttrs.touched}
        changed={e => copyInputChanged(formKey, e)}
        inputValue={formAttrs.value}
        validationError={formAttrs.error}
      />
    )
  })
  return (
    <Modal
      open={open}
      onHide={cancelled}
      header={translate('copyAssignment')}
      footer={<Footer onSave={copySaved} onHide={cancelled} saveDisabled={!formValid} />}>
      {copyInputs}
    </Modal>
  )
}

export default withTranslate(copyModal)
